(function () {
  let cartFetchPromise;

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setLoading(button, isLoading) {
    if (!button) return;

    const spinner = button.querySelector('.loading__spinner');

    if (isLoading) {
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
      return;
    }

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    button.disabled = false;
    if (spinner) spinner.classList.add('hidden');
  }

  function setSiblingButtonsDisabled(container, shouldDisable) {
    if (!container) return;

    container.querySelectorAll('.custom-card__btn').forEach(function (button) {
      if (button.matches('[data-buy-now]')) return;

      if (shouldDisable) {
        button.setAttribute('aria-disabled', 'true');
        button.disabled = true;
      } else {
        button.removeAttribute('aria-disabled');
        button.disabled = false;
      }
    });
  }

  function buildVariantQuantityMap(cart) {
    const quantities = new Map();
    if (!cart || !Array.isArray(cart.items)) return quantities;

    cart.items.forEach(function (item) {
      const variantId = Number(item.id);
      const quantity = Number(item.quantity) || 0;
      quantities.set(variantId, (quantities.get(variantId) || 0) + quantity);
    });

    return quantities;
  }

  function renderAddButtonCounts(cart) {
    const quantities = buildVariantQuantityMap(cart);

    document.querySelectorAll('[data-add-to-cart-btn]').forEach(function (button) {
      const variantId = Number(button.getAttribute('data-variant-id'));
      const count = quantities.get(variantId) || 0;
      const countDisplay = count > 99 ? '99+' : String(count);

      if (count > 0) {
        button.dataset.cartCountDisplay = countDisplay;
      } else {
        delete button.dataset.cartCountDisplay;
      }

      button.setAttribute('aria-label', count > 0 ? 'Add to cart. In cart: ' + count : 'Add to cart');
    });
  }

  async function fetchCart() {
    if (cartFetchPromise) return cartFetchPromise;

    cartFetchPromise = fetch(getRoot() + 'cart.js', {
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart state');
        }
        return response.json();
      })
      .finally(function () {
        cartFetchPromise = null;
      });

    return cartFetchPromise;
  }

  function refreshAddButtonCounts() {
    fetchCart()
      .then(function (cart) {
        renderAddButtonCounts(cart);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function scheduleCountRefresh() {
    window.setTimeout(refreshAddButtonCounts, 450);
    window.setTimeout(refreshAddButtonCounts, 1100);
  }

  function handleBuyNow(button) {
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

    const actions = button.closest('.custom-card__actions');
    const errorMessage = actions ? actions.querySelector('[data-buy-now-error]') : null;

    if (errorMessage) {
      errorMessage.hidden = true;
      errorMessage.textContent = '';
    }

    setLoading(button, true);
    setSiblingButtonsDisabled(actions, true);

    const root = getRoot();
    const redirectUrl =
      root +
      'cart/add?id=' +
      encodeURIComponent(variantId) +
      '&quantity=1&return_to=' +
      encodeURIComponent(root + 'checkout');

    window.location.assign(redirectUrl);
  }

  document.addEventListener('click', function (event) {
    const buyNowButton = event.target.closest('[data-buy-now]');
    if (!buyNowButton) return;

    event.preventDefault();
    handleBuyNow(buyNowButton);
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('product-form form[data-type="add-to-cart-form"]');
    if (!form) return;

    if (!form.closest('.custom-card__actions')) return;

    scheduleCountRefresh();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      refreshAddButtonCounts();
    });
  }

  document.addEventListener('DOMContentLoaded', refreshAddButtonCounts);
})();
